import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {useVerifiedPermissions} from "../../../hooks/useVerifiedPermissions.ts";
import {rbacActions} from "../../../config/rbac/actions.ts";
import {ReloadRecordsButton} from '../buttons/ReloadRecordsButton.tsx';
import {FilterRecordsButton} from '../buttons/FilterRecordsButton.tsx';
import {DeleteRecordButton} from "../buttons/DeleteRecordButton.tsx";
import {AddRecordButton} from "../buttons/AddRecordButton.tsx";
import {moduleConfig} from "../config";
import {CloneRecordsButton} from "../buttons/CloneRecordsButton.tsx";
import { GenerateProductsButton } from '../../test-data-generator/buttons/GenerateProductsButton.tsx';
import { ProductStatus } from '../types';

interface IndexPageHeaderProps {
    onFilterChange: (status: ProductStatus | null) => void;
}

const useTools = (onFilterChange: (status: ProductStatus | null) => void) => {
    const {allowedActions} = useVerifiedPermissions();

    const tools = [];

    tools.push(<FilterRecordsButton key='filter' onFilterChange={onFilterChange} />);
    tools.push(<ReloadRecordsButton key='reload'/>);

    if (allowedActions.includes(rbacActions.DeleteProduct)) {
        tools.push(<CloneRecordsButton key='clone' onClick={() => {/* TODO: Implement clone functionality */}}/>);
    }

    if (allowedActions.includes(rbacActions.DeleteProduct)) {
        tools.push(<DeleteRecordButton key='delete'/>);
    }

    if (allowedActions.includes(rbacActions.CreateProduct)) {
        tools.push(<AddRecordButton key='add'/>);
        tools.push(<GenerateProductsButton key='generate'/>);
    }

    return tools;
};

export const IndexPageHeader = ({ onFilterChange }: IndexPageHeaderProps) => {
    return (
        <SimplePageHeader
            title={I18n.get(moduleConfig.titles.plural)}
            tools={useTools(onFilterChange)}
        />
    );
};
